import { z } from 'zod';

import { TeamSpecialistRoleId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';

export const TeamSpecialistRole = z.object({
  id: zodBrandedUuid<TeamSpecialistRoleId>(),
  title: z.string(),
  key: z.string(), // unique key for bulk update report
});

export type TeamSpecialistRole = z.infer<typeof TeamSpecialistRole>;
